import React from 'react';
import './Card.scss'

function CardInfo(props) {


    return (
        <div className="g-card-info">
            <p className="g-card-title">{props.title}</p>
            <p className="g-card-subTitle">{props.subTitle}</p>
            <p className="g-card-subTitle">{props.category}</p>
        </div>
    );
}

export default CardInfo;